import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { FunnelProvider } from "./context/FunnelContext";
import { useLenis } from "./hooks/useLenis";
import { Toaster } from "./components/ui/sonner";
import { SiteHeader } from "./components/SiteHeader";
import WelcomePage from "./pages/WelcomePage";
import QualifyingPage from "./pages/QualifyingPage";
import SegmentationPage from "./pages/SegmentationPage";
import OfferPage from "./pages/OfferPage";
import BookingPage from "./pages/BookingPage";
import ThankYouPage from "./pages/ThankYouPage";
import AdminPage from "./pages/AdminPage";

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<WelcomePage />} />
        <Route path="/discover" element={<QualifyingPage />} />
        <Route path="/explore" element={<SegmentationPage />} />
        <Route path="/offer" element={<OfferPage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  useLenis();
  return (
    <FunnelProvider>
      <BrowserRouter>
        <div className="App min-h-screen bg-[#FBF9F5]">
          <SiteHeader />
          <AnimatedRoutes />
          <Toaster />
        </div>
      </BrowserRouter>
    </FunnelProvider>
  );
}

export default App;
